import authConfig from "emun.auth/auth.config"; //get shared
import basicController from "servicestack/basic.controller.properties";
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";

export default class VerifyEmailController {
  constructor($scope) {
    basicController(this);
    const $ctrl = this;
    $ctrl.bus = $ctrl.$session.bus;
    delete $ctrl.bus.validationErrors;
    $ctrl.config = authConfig;
    $ctrl.processed = false;
    $scope.$watch(
      () => $ctrl.email,
      () => {
        if (!$ctrl.email) $ctrl.processed = false;
      }
    );
  }

  queryRegistrationEmails() {
    const $ctrl = this;
    const { request = {}, email } = $ctrl;
    return $ctrl.bus
      .read(`QueryRegistrationEmails/${email || request.email}`)
      .then(({ data }) => {
        if (data.length) {
          const [retailerId] = data;
          request.retailerId = retailerId;
        }
      });
  }

  gotoRegistration() {
    const $ctrl = this;
    location.href = $ctrl.registrationUrl + "?email=" + $ctrl.email;
  }

  gotoLogin() {
    const $ctrl = this;
    location.href = $ctrl.loginUrl + "?email=" + $ctrl.email;
  }

  submit() {
    const $ctrl = this;
    delete $ctrl.user;
    delete $ctrl.retailer;
    $ctrl.bus
      .read(`QueryUserEmail.json`, { email: $ctrl.email })
      .then(({ data }) => {
        if (data.results.length) {
          $ctrl.user = data.results[0];
          $ctrl.processed = true;
        } else {
          //OTP
          if ($ctrl.config.useOneTimePasscode) {
            return $ctrl.$session
            .requestOneTimePasscode($ctrl.email, {
              usePrompt: true,
              login: false,
            })
            .then(() => {
              $ctrl.checkRegistrationEmails();
            });
          } else {
            $ctrl.checkRegistrationEmails();
          }
        }
      });
  }

  checkRegistrationEmails() {
    const $ctrl = this;
    $ctrl.bus
    .read(`QueryRegistrationEmails/${$ctrl.email}`)
    .then(({ data }) => {
      console.debug("QueryRegistrationEmails", data);
      if (data.length) {
        $ctrl.retailerId = data[0];
        console.debug(
          "QueryRegistrationEmailsResults",
          $ctrl.retailerId
        );
        $ctrl.bus
          .read(`GetRetailer.json?Id=${$ctrl.retailerId}`)
          .then(({ data }) => {
            if (data.results.length) {
              $ctrl.retailer = data.results[0];
            } else {
              $ctrl.gotoRegistration();
            }
          });
      } else {
        $ctrl.gotoRegistration();
      }
      $ctrl.processed = true;
    })

  }

  resetPassword() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("resetPassword");
    return resetPasswordPrompt({ email: $ctrl.email });
  }

  setFocus(id) {
    let $ctrl = this;
    setTimeout(function () {
      var element = window.document.getElementById(id);
      if (element) {
        element.focus();
      }
    }, 500);
  }
}
